import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import Layout from '../components/layout';
import SEO from '../components/seo';
import Hero from '../components/hero';
import SideBySide from '../components/side-by-side';
// import TeamTile from "../components/team-tile";
import TeamGrid from '../components/team-grid';
import DialogButton from '../components/dialogButton';

const About = () => {
    const data = useStaticQuery(graphql`
        query {
            hero: file(relativePath: { eq: "about-hero4.jpeg" }) {
                childImageSharp {
                    fluid(maxWidth: 2600, jpegQuality: 80) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
            map: file(relativePath: { eq: "weave-map.png" }) {
                childImageSharp {
                    fluid(maxWidth: 800) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `);

    return (
        <Layout>
            <SEO
                title="About"
                url="/about-weave"
                description="Weave was founded in Boulder, Colorado in 2014. Our goal is to provide high performance and regulatory compliant cannabis applications. We are known for our customer service and we take our clients' happiness seriously. Catch us continually innovating our product to keep pace with the rapidly changing demands of the cannabis marketplace."
            />
            <Hero
                buttonsList={[
                    <DialogButton analyticsValue={3} key="talk">
                        Get Started Today
                    </DialogButton>,
                ]}
                copy="Weave was founded in Boulder, Colorado in 2014. Our goal is to provide high performance and regulatory compliant cannabis applications. We are known for our customer service and we take our clients' happiness seriously. Catch us continually innovating our product to keep pace with the rapidly changing demands of the cannabis marketplace."
                header="Weave Got a Vision"
                image={data.hero.childImageSharp.fluid}
            />
            <div className="parallax-section weave-map">
                <SideBySide
                    buttonsList={[
                        <DialogButton key="one">grow with us</DialogButton>,
                    ]}
                    copy={[
                        `Weave is available where your cannabis business is located. We currently operate in eight states while continuing to grow wherever our customers do.`,
                        <br key="yaya"></br>,
                        <br key="yayay"></br>,
                        <p>
                            We work with small shops to multi-state operators,
                            ensuring your dispensary is compliant with the
                            regulations in your state. Let us navigate the
                            challenges, so you can focus on serving your
                            customers.
                        </p>,
                    ]}
                    header="Where We're Located"
                    image={data.map.childImageSharp.fluid}
                    imagePosition={'left'}
                />
            </div>
            <TeamGrid />
        </Layout>
    );
};

export default About;
